import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function createHotelContract({ hotelId, contract }) {
  const {
    host,
    URIs: { createHotelContract },
  } = apiConfig;

  const uri = `${host}${createHotelContract}`;

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));
  
  const form = new FormData();
  form.append('contract_file', contract.fileToUpload);
  form.append('data[name]', contract.name);
  form.append('data[hotelId]', hotelId);
  form.append('data[hotelReference]', 'civitfun');
  if ( contract.orderNumber ) {
    form.append('data[orderNumber]', contract.orderNumber);
  }
  form.append('data[signatureDate]', contract.signatureDate.format('YYYY-MM-DD'));
  form.append('data[accessToken]', storedCredentials.accessToken);

  return axios
    .post(uri, form)
    .then(res => {
      return res.data;
    });
}
